module.exports = __webpack_public_path__ + "static/media/006-emoji-4.5cf827db.svg";